import script from "./CryptoTransaction.vue?vue&type=script&lang=ts&setup=true"
export * from "./CryptoTransaction.vue?vue&type=script&lang=ts&setup=true"

import "./CryptoTransaction.vue?vue&type=style&index=0&id=28daf83a&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28daf83a"]])

export default __exports__